import { render, staticRenderFns } from "./SalaryLogs.vue?vue&type=template&id=2df01d54&scoped=true"
import script from "./SalaryLogs.vue?vue&type=script&lang=js"
export * from "./SalaryLogs.vue?vue&type=script&lang=js"
import style0 from "./SalaryLogs.vue?vue&type=style&index=0&id=2df01d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df01d54",
  null
  
)

export default component.exports